import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '分类', path: '/category/all' },
    { name: '关于我们', path: '/about' },
    { name: '网站地图', path: '/sitemap' },
  ],
  legal: [
    { name: '隐私政策', path: '/privacy' },
    { name: '服务条款', path: '/terms' },
    { name: '版权声明', path: '/copyright' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            <div>
              <Link to="/" className="inline-block cursor-pointer">
                <span className="text-2xl font-heading font-bold text-background-50 whitespace-nowrap">韩漫世界</span>
              </Link>
              <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-xs">
                韩漫免费网站汇聚韩国漫画大全，提供无删减韩漫在线免费观看。高清画质与流畅阅读体验，让您随时随地享受精彩故事。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-sm" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-sm" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="B站" rel="nofollow">
                  <i className="ri-bilibili-line text-sm" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer" aria-label="QQ" rel="nofollow">
                  <i className="ri-qq-line text-sm" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold text-background-50 uppercase tracking-wider mb-4 whitespace-nowrap">快速导航</h4>
              <ul className="space-y-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <h4 className="text-sm font-label font-semibold text-background-50 uppercase tracking-wider mb-4 mt-8 whitespace-nowrap">法律信息</h4>
              <ul className="space-y-2.5">
                {footerLinks.legal.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold text-background-50 uppercase tracking-wider mb-4 whitespace-nowrap">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-foreground-400 mt-0.5 text-sm" />
                  <span className="text-sm text-foreground-400">北京市朝阳区望京SOHO T1-B座 1808室</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-foreground-400 text-sm" />
                  <span className="text-sm text-foreground-400">400-888-6666</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-foreground-400 text-sm" />
                  <span className="text-sm text-foreground-400">hello@lczydmb.com</span>
                </li>
              </ul>
              <div className="mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20QR%20code%20placeholder%20design%20with%20soft%20geometric%20patterns%20in%20dark%20gray%20and%20white%20modern%20simple%20style%20on%20dark%20background&width=280&height=400&seq=footer-qr-placeholder&orientation=portrait"
                  alt="关注我们"
                  title="扫码关注韩漫免费网站"
                  className="w-24 h-auto rounded-lg opacity-70"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2026 韩漫免费网站 版权所有
            </p>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="text-xs text-foreground-500 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">隐私政策</Link>
              <Link to="/terms" className="text-xs text-foreground-500 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">服务条款</Link>
              <Link to="/sitemap" className="text-xs text-foreground-500 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap">网站地图</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}